<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<app-data-table-ajax *ngIf="role?.id && user?.username"
                     #dataTableAjax
                     [url]="dataTableUrl"
                     limit="50"
                     [columns]="columns"
                     >
</app-data-table-ajax>

<ng-template 
             #actionTemplate 
             let-row="row">
  <button i18n
          type="button"
          class="btn btn-link p-0 m-0"
          (click)="$event.preventDefault(); $event.stopPropagation(); onRemoveRow(row)">
    <img alt="Delete Role"
         title="Delete Role"
         class="row-icon"
         src="assets/_ionicons_svg_md-trash.svg">
  </button>

</ng-template>


// WEBPACK FOOTER //
// ./src/app/access-management/roles/role-scope-card/role-scope-card.component.html